/*=========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - Clean Vue.js Dashboard Admin Template
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/
// import { appCode } from '@/environment/environment';

const appCode = 'myers';

let commonConfig = {
	numerals: {
		en_EU: {
			delimiters: {
				thousands: ' ',
				decimal: ','
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				let value = 'th';
				switch (number) {
					case 0:
						value = 'th';
						break;
					case 1:
						value = 'st';
						break;
					case 2:
						value = 'nd';
						break;
					case 3:
						value = 'rd';
						break;
					default:
						value = 'th';
				}
				return value;
			},
			currency: {
				symbol: '€'
			}
		},
		fr_EU: {
			delimiters: {
				thousands: ' ',
				decimal: ','
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				return number === 1 ? 'er' : 'ème';
			},
			currency: {
				symbol: '€'
			}
		},
		en_IN: {
			delimiters: {
				thousands: ',',
				decimal: '.'
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				let value = 'th';
				switch (number) {
					case 0:
						value = 'th';
						break;
					case 1:
						value = 'st';
						break;
					case 2:
						value = 'nd';
						break;
					case 3:
						value = 'rd';
						break;
					default:
						value = 'th';
				}
				return value;
			},
			currency: {
				symbol: '₹'
			}
		},
		en_US: {
			delimiters: {
				thousands: ',',
				decimal: '.'
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				let value = 'th';
				switch (number) {
					case 0:
						value = 'th';
						break;
					case 1:
						value = 'st';
						break;
					case 2:
						value = 'nd';
						break;
					case 3:
						value = 'rd';
						break;
					default:
						value = 'th';
				}
				return value;
			},
			currency: {
				symbol: '$'
			}
		},
		en_AE: {
			delimiters: {
				thousands: ',',
				decimal: '.'
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				let value = 'th';
				switch (number) {
					case 0:
						value = 'th';
						break;
					case 1:
						value = 'st';
						break;
					case 2:
						value = 'nd';
						break;
					case 3:
						value = 'rd';
						break;
					default:
						value = 'th';
				}
				return value;
			},
			currency: {
				symbol: 'د.إ'
			}
		},
		en_OM: {
			delimiters: {
				thousands: ',',
				decimal: '.'
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				let value = 'th';
				switch (number) {
					case 0:
						value = 'th';
						break;
					case 1:
						value = 'st';
						break;
					case 2:
						value = 'nd';
						break;
					case 3:
						value = 'rd';
						break;
					default:
						value = 'th';
				}
				return value;
			},
			currency: {
				symbol: 'ر.ع.'
			}
		},
		en_BH: {
			delimiters: {
				thousands: ',',
				decimal: '.'
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				let value = 'th';
				switch (number) {
					case 0:
						value = 'th';
						break;
					case 1:
						value = 'st';
						break;
					case 2:
						value = 'nd';
						break;
					case 3:
						value = 'rd';
						break;
					default:
						value = 'th';
				}
				return value;
			},
			currency: {
				symbol: '.د.ب'
			}
		},
		en_EG: {
			delimiters: {
				thousands: ',',
				decimal: '.'
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				let value = 'th';
				switch (number) {
					case 0:
						value = 'th';
						break;
					case 1:
						value = 'st';
						break;
					case 2:
						value = 'nd';
						break;
					case 3:
						value = 'rd';
						break;
					default:
						value = 'th';
				}
				return value;
			},
			currency: {
				symbol: 'ج.م'
			}
		},
		en_AU: {
			delimiters: {
				thousands: ',',
				decimal: '.'
			},
			abbreviations: {
				thousand: 'k',
				million: 'm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				let value = 'th';
				switch (number) {
					case 0:
						value = 'th';
						break;
					case 1:
						value = 'st';
						break;
					case 2:
						value = 'nd';
						break;
					case 3:
						value = 'rd';
						break;
					default:
						value = 'th';
				}
				return value;
			},
			currency: {
				symbol: 'A$'
			}
		},
		pt_BR: {
			delimiters: {
				thousands: '.',
				decimal: ','
			},
			abbreviations: {
				thousand: 'mil',
				million: 'milhões',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				return 'º';
			},
			currency: {
				symbol: 'R$'
			}
		},
		es_MX: {
			delimiters: {
				thousands: '.',
				decimal: ','
			},
			abbreviations: {
				thousand: 'k',
				million: 'mm',
				billion: 'b',
				trillion: 't'
			},
			ordinal: function (number) {
				var b = number % 10;
				return (b === 1 || b === 3) ? 'er' :
					(b === 2) ? 'do' :
					(b === 7 || b === 0) ? 'mo' :
			(b === 8) ? 'vo' :
			(b === 9) ? 'no' : 'to';
			},
			currency: {
				symbol: '$'
			}
		},
	},
	date: {
		dayOfWeekNames: [
			'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday',
			'Friday', 'Saturday'
		],
		dayOfWeekNamesNamesShort: [
			'Su', 'Mo', 'Tu', 'We', 'Tr', 'Fr', 'Sa'
		],
		monthNames: [
			'January', 'February', 'March', 'April', 'May', 'June',
			'July', 'August', 'September', 'October', 'November', 'December'
		],
		monthNamesShort: [
			'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
			'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
		]
	},
	color: {
		blue: '#1877f2',
		yellow: '#f1c40f',
		lime: '#76c900',
		navy: '#0a4069',
		cyan: '#57caf4',
		red: '#ec008c',
		white: '#fefefe',
		gray: '#4a4a4a',
		strawberry: '#E8548A',
		peach: '#FF6F69',
		orange: '#FF9D4F',
		egg: '#FFCC5C',
		cupcake: '#FFEDAC',
		palmtree: '#97DB94',
		water: '#35B8CC',
		sky: '#94D4DB',
		night: '#122338',
		darkness: '#101E30'
	}
};

let platformConfig = {
	// MAIN COLORS - VUESAX THEME COLORS
	app: {
		colors: {
			primary: '#7367F0',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			navbarColor: '#7367F0'
		},
		config: {
			locale: 'fr_EU',
			logo: 'logo-app.png',
			hasLogoFull: false,
			logoFull: 'logo-full-app.png',
			title: 'ApPyVue',
			hasPartner: false,
			logoPartner: 'logo-app.png'
		},
		menu: [
			{
				url: null,
				name: 'Analyze',
				slug: 'analyze',
				icon: 'HomeIcon',
				i18n: 'analyze',
				// isDisabled: true,
				submenu: [
					{
						url: '/analyze/dashboard',
						name: 'Dashboard',
						slug: 'analyzeDashboard',
						i18n: 'Dashboard',
					},
					{
						url: '/analyze/alerts',
						name: 'Alerts',
						slug: 'analyzeAlerts',
						i18n: 'Alerts',
					},
					{
						url: '/analyze/explore',
						name: 'Insights',
						slug: 'analyzeExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Insights',
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/analyze/dashboard',                icon: 'HomeIcon',           is_bookmarked: false},
					{title: 'Alerts',                     url: '/analyze/alerts',                   icon: 'AlertOctagonIcon',   is_bookmarked: true},
					{title: 'Insights',                   url: '/analyze/explore',                  icon: 'EyeIcon',            is_bookmarked: true},
				]
			}
		},
		chart: {
			colors: ["#7367F0", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"]
		}
	},
	// CUSTOM COLORS - ApPyVue THEME COLORS
	nex: {
		colors: {
			primary: '#229dca',//'#7367F0',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			navbarColor: '#229dca'
		},
		config: {
			locale: 'en_US',
			logo: 'logo-nex.png',
			hasLogoFull: true,
			logoFull: 'logo-full-nex.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-nex.png'
		},
		menu: [
			{
				url: null,
				name: 'Analyze',
				slug: 'analyze',
				icon: 'HomeIcon',
				i18n: 'analyze',
				// isDisabled: true,
				submenu: [
					{
						url: '/analyze/dashboard',
						name: 'Dashboard',
						slug: 'analyzeDashboard',
						i18n: 'Dashboard',
					},
					{
						url: '/analyze/alerts',
						name: 'Alerts',
						slug: 'analyzeAlerts',
						i18n: 'Alerts',
					},
					{
						url: '/analyze/explore',
						name: 'Insights',
						slug: 'analyzeExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Insights',
					}
				]
			},
			{
				header: 'Sandbox',
				i18n: 'Sandbox',
				items: [
					{
						url: '/sandbox/explore',
						name: 'Explore',
						slug: 'sandboxExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Explore',
					}
				]
			},

			{
				header: 'Orbits',
				i18n: 'Orbits',
				items: [
					{
						url: '/orbit/predictor',
						name: 'DemFor',
						slug: 'predictor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					},
					{
						url: '/orbit/optimizer',
						name: 'PriceMind',
						slug: 'optimizer',
						icon: 'DollarSignIcon',
						i18n: 'PriceMind',
						// isDisabled: true
					},
					{
						url: '/competer/dashboard',
						name: 'PriceEye',
						slug: 'competer',
						icon: 'EyeIcon',
						i18n: 'PriceEye',
						// isDisabled: true
					},
					// {
					// 	url: '',
					// 	name: 'PriceEye',
					// 	slug: 'competer',
					// 	icon: 'EyeIcon',
					// 	i18n: 'PriceEye',
					// 	// isDisabled: true,
					// 	submenu: [
					// 		{
					// 			url: '/competer/dashboard',
					// 			name: 'Dashboard',
					// 			slug: 'competerDashboard',
					// 			i18n: 'Dashboard',
					// 		},
					// 		{
					// 			url: '/competer/alerts',
					// 			name: 'Alerts',
					// 			slug: 'competerAlerts',
					// 			i18n: 'Alerts',
					// 		},
					// 		{
					// 			url: '/competer/explore',
					// 			name: 'Insights',
					// 			slug: 'competerExplore',
					// 			icon: 'CodesandboxIcon',
					// 			i18n: 'Insights',
					// 		}
					// 	]
					// },
					{
						url: '/orbits/order',
						name: 'Store Order',
						slug: 'order',
						icon: 'TruckIcon',
						i18n: 'Store Order',
						isDisabled: true
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						// isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						// isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/analyze/dashboard',                icon: 'HomeIcon',           is_bookmarked: false},
					{title: 'Alerts',                     url: '/analyze/alerts',                   icon: 'AlertOctagonIcon',   is_bookmarked: true},
					{title: 'Insights',                   url: '/analyze/explore',                  icon: 'EyeIcon',            is_bookmarked: true},
					{title: 'Sandbox',                    url: '/sandbox/explore',                  icon: 'CodesandboxIcon',    is_bookmarked: true},
					{title: 'Demand Forecast',            url: '/orbit/predictor',                  icon: 'SlidersIcon',        is_bookmarked: false},
					{title: 'Price Optimize',             url: '/orbit/optimizer',                  icon: 'DollarSignIcon',     is_bookmarked: false},
					{title: 'Price Eye',            	  url: '/competer/dashboard',               icon: 'EyeIcon',        	 is_bookmarked: false},
				]
			}
		},
		chart: {
			colors: ["#229dca", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"]
		}
	},
	libertas: {
		colors: {
			primary: '#5ec7ff', //'#3472cd',//'#49e4f8',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			note: '#5ec7ff',
			navbarColor: '#5ec7ff'
		},
		config: {
			locale: 'en_US',
			logo: 'logo-nex.png',
			hasLogoFull: true,
			logoFull: 'logo-full-nex.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-nex.png',
			env: 'lite'
		},
		menu: [
			{
				url: null,
				name: 'Analyze',
				slug: 'analyze',
				icon: 'HomeIcon',
				i18n: 'analyze',
				// isDisabled: true,
				submenu: [
					{
						url: '/analyze/dashboard',
						name: 'Dashboard',
						slug: 'analyzeDashboard',
						i18n: 'Dashboard',
					},
					{
						url: '/analyze/alerts',
						name: 'Alerts',
						slug: 'analyzeAlerts',
						i18n: 'Alerts',
					},
					{
						url: '/analyze/explore',
						name: 'Insights',
						slug: 'analyzeExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Insights',
					}
				]
			},
			{
				header: 'Sandbox',
				i18n: 'Sandbox',
				items: [
					{
						url: '/sandbox/explore',
						name: 'Explore',
						slug: 'sandboxExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Explore',
					}
				]
			},

			{
				header: 'Orbits',
				i18n: 'Orbits',
				items: [
					{
						url: '/orbit/predictor',
						name: 'DemFor',
						slug: 'predictor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					},
					{
						url: '/orbit/optimizer',
						name: 'PriceMind',
						slug: 'optimizer',
						icon: 'DollarSignIcon',
						i18n: 'PriceMind',
						// isDisabled: true
					},
					{
						url: '/competer/dashboard',
						name: 'PriceEye',
						slug: 'competer',
						icon: 'EyeIcon',
						i18n: 'PriceEye',
						// isDisabled: true
					},
					// {
					// 	url: '',
					// 	name: 'PriceEye',
					// 	slug: 'competer',
					// 	icon: 'EyeIcon',
					// 	i18n: 'PriceEye',
					// 	// isDisabled: true,
					// 	submenu: [
					// 		{
					// 			url: '/competer/dashboard',
					// 			name: 'Dashboard',
					// 			slug: 'competerDashboard',
					// 			i18n: 'Dashboard',
					// 		},
					// 		{
					// 			url: '/competer/alerts',
					// 			name: 'Alerts',
					// 			slug: 'competerAlerts',
					// 			i18n: 'Alerts',
					// 		},
					// 		{
					// 			url: '/competer/explore',
					// 			name: 'Insights',
					// 			slug: 'competerExplore',
					// 			icon: 'CodesandboxIcon',
					// 			i18n: 'Insights',
					// 		}
					// 	]
					// },
					{
						url: '/orbits/order',
						name: 'Store Order',
						slug: 'order',
						icon: 'TruckIcon',
						i18n: 'Store Order',
						isDisabled: true
					}
				]
			},
			// {
			// 	header: 'Discover',
			// 	i18n: 'Discover',
			// 	items: [
			// 		{
			// 			url: '/competer/discover',
			// 			name: 'Discover',
			// 			slug: 'competerDiscover',
			// 			icon: 'CodesandboxIcon',
			// 			i18n: 'Discover',
			// 		}
			// 	]
			// },

			{
				header: 'Senser',
				i18n: 'Senser',
				items: [
					{
						url: '/senser/dashboard',
						name: 'Dashboard',
						slug: 'dashboard',
						icon: 'SlidersIcon',
						i18n: 'Dashboard',
						// isDisabled: true
					},
					{
						url: '/senser/demfor',
						name: 'DemFor',
						slug: 'demfor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					}
				]
			},

			{
				header: 'Onboard',
				i18n: 'Onboard',
				items: [
					{
						url: '/onboard/entities',
						name: 'Entities',
						slug: 'entities',
						icon: 'SlidersIcon',
						i18n: 'Entities',
						// isDisabled: true
					},
					{
						url: '/onboard/user-list',
						name: 'Users',
						slug: 'users',
						icon: 'SlidersIcon',
						i18n: 'Users',
						// isDisabled: true
					},
					{
						url: '/onboard/settings',
						name: 'Settings',
						slug: 'settings',
						icon: 'DollarSignIcon',
						i18n: 'Settings',
						// isDisabled: true
					}
				]
			},

			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						// isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						// isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/analyze/dashboard',                icon: 'HomeIcon',           is_bookmarked: false},
					{title: 'Alerts',                     url: '/analyze/alerts',                   icon: 'AlertOctagonIcon',   is_bookmarked: true},
					{title: 'Insights',                   url: '/analyze/explore',                  icon: 'EyeIcon',            is_bookmarked: true},
					{title: 'Sandbox',                    url: '/sandbox/explore',                  icon: 'CodesandboxIcon',    is_bookmarked: true},
					{title: 'Demand Forecast',            url: '/orbit/predictor',                  icon: 'SlidersIcon',        is_bookmarked: false},
					{title: 'Price Optimize',             url: '/orbit/optimizer',                  icon: 'DollarSignIcon',     is_bookmarked: false},
					{title: 'Price Eye',            	  url: '/competer/dashboard',               icon: 'EyeIcon',        	 is_bookmarked: false},
				]
			}
		},
		chart: {
			colors: ["#5ec7ff", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00"]
		}
	},
	demo: {
		colors: {
			primary: '#1877f2',//'#5ec7ff', //'#d41545',//'#3472cd',//'#49e4f8',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			note: '#5ec7ff',
			// navbarColor: commonConfig.color.white
		},
		config: {
			locale: 'en_US',
			logo: 'logo-nex.png',
			hasLogoFull: true,
			logoFull: 'logo-full-nex.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-xyz.png',
			env: 'lite',
			landingUrl: '/competer/dashboard'
		},
		menu: [
			{
				header: 'Orbits',
				i18n: 'Orbits',
				items: [
					{
						url: '/competer/dashboard',
						name: 'PriceEye',
						slug: 'competer',
						icon: 'EyeIcon',
						i18n: 'PriceEye',
						// isDisabled: true
					},
					{
						url: '/orbit/predictor',
						name: 'DemFor',
						slug: 'predictor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					},
					{
						url: '/orbit/optimizer',
						name: 'PriceMind',
						slug: 'optimizer',
						icon: 'DollarSignIcon',
						i18n: 'PriceMind',
						// isDisabled: true
					},
					{
						url: '/orbits/order',
						name: 'Store Order',
						slug: 'order',
						icon: 'TruckIcon',
						i18n: 'Store Order',
						isDisabled: true
					}
				]
			},
			{
				header: 'Intelligence',
				i18n: 'Intelligence',
				items: [
					{
						url: '/analyze/dashboard',
						name: 'Dashboard',
						slug: 'analyzeDashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
					},
					{
						url: '/analyze/alerts',
						name: 'Alerts',
						slug: 'analyzeAlerts',
						icon: 'BellIcon',
						i18n: 'Alerts',
					},
					{
						url: '/analyze/explore',
						name: 'Insights',
						slug: 'analyzeExplore',
						icon: 'ActivityIcon',
						i18n: 'Insights',
					},
					{
						url: '/sandbox/explore',
						name: 'Explore',
						slug: 'sandboxExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Explore',
					}
				]
			},
			{
				header: 'Market Focus',
				i18n: 'Market Focus',
				items: [
					{
						url: '/senser/dashboard',
						name: 'Dashboard',
						slug: 'dashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
						// isDisabled: true
					},
					{
						url: '/senser/demfor',
						name: 'DemFor',
						slug: 'demfor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/analyze/dashboard',                icon: 'HomeIcon',           is_bookmarked: false},
					{title: 'Alerts',                     url: '/analyze/alerts',                   icon: 'AlertOctagonIcon',   is_bookmarked: true},
					{title: 'Insights',                   url: '/analyze/explore',                  icon: 'EyeIcon',            is_bookmarked: true},
					{title: 'Sandbox',                    url: '/sandbox/explore',                  icon: 'CodesandboxIcon',    is_bookmarked: true},
					{title: 'Demand Forecast',            url: '/orbit/predictor',                  icon: 'SlidersIcon',        is_bookmarked: false},
					{title: 'Price Optimize',             url: '/orbit/optimizer',                  icon: 'DollarSignIcon',     is_bookmarked: false},
					{title: 'Price Eye',            	  url: '/competer/dashboard',               icon: 'EyeIcon',        	 is_bookmarked: false},
				]
			}
		},
		chart: {
			colors: [commonConfig.color.blue, commonConfig.color.navy, commonConfig.color.water, commonConfig.color.cupcake, commonConfig.color.cyan, commonConfig.color.darkness, commonConfig.color.lime, commonConfig.color.egg, commonConfig.color.gray]
			// colors: ["#5ec7ff", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00"]
			// colors: ["#aa2a3d", "#c42f58", "#d41545", "#e92343", "#f54b2d", "#FF9F43", "#f2bb3c", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00", "#f54b2f"]
		}
	},
	jkp: {
		colors: {
			primary: '#254689',//'#5ec7ff', //'#3472cd',//'#49e4f8',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			note: '#254689',
			navbarColor: '#254689'
		},
		config: {
			locale: 'en_IN',
			logo: 'logo-nex.png',
			hasLogoFull: true,
			logoFull: 'logo-full-nex.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-jkp.png',
			env: 'lite',
			landingUrl: '/senser/dashboard'
		},
		menu: [
			{
				url: null,
				name: 'Analyze',
				slug: 'analyze',
				icon: 'HomeIcon',
				i18n: 'analyze',
				// isDisabled: true,
				submenu: [
					{
						url: '/analyze/dashboard',
						name: 'Dashboard',
						slug: 'analyzeDashboard',
						i18n: 'Dashboard',
					},
					{
						url: '/analyze/alerts',
						name: 'Alerts',
						slug: 'analyzeAlerts',
						i18n: 'Alerts',
					},
					{
						url: '/analyze/explore',
						name: 'Insights',
						slug: 'analyzeExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Insights',
					}
				]
			},
			{
				header: 'Sandbox',
				i18n: 'Sandbox',
				items: [
					{
						url: '/sandbox/explore',
						name: 'Explore',
						slug: 'sandboxExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Explore',
					}
				]
			},

			{
				header: 'Orbits',
				i18n: 'Orbits',
				items: [
					{
						url: '/orbit/predictor',
						name: 'DemFor',
						slug: 'predictor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					},
					{
						url: '/orbit/optimizer',
						name: 'PriceMind',
						slug: 'optimizer',
						icon: 'DollarSignIcon',
						i18n: 'PriceMind',
						// isDisabled: true
					},
					// {
					// 	url: '/competer/dashboard',
					// 	name: 'PriceEye',
					// 	slug: 'competer',
					// 	icon: 'EyeIcon',
					// 	i18n: 'PriceEye',
					// 	// isDisabled: true
					// },
					// {
					// 	url: '',
					// 	name: 'PriceEye',
					// 	slug: 'competer',
					// 	icon: 'EyeIcon',
					// 	i18n: 'PriceEye',
					// 	// isDisabled: true,
					// 	submenu: [
					// 		{
					// 			url: '/competer/dashboard',
					// 			name: 'Dashboard',
					// 			slug: 'competerDashboard',
					// 			i18n: 'Dashboard',
					// 		},
					// 		{
					// 			url: '/competer/alerts',
					// 			name: 'Alerts',
					// 			slug: 'competerAlerts',
					// 			i18n: 'Alerts',
					// 		},
					// 		{
					// 			url: '/competer/explore',
					// 			name: 'Insights',
					// 			slug: 'competerExplore',
					// 			icon: 'CodesandboxIcon',
					// 			i18n: 'Insights',
					// 		}
					// 	]
					// },
					{
						url: '/orbits/order',
						name: 'Store Order',
						slug: 'order',
						icon: 'TruckIcon',
						i18n: 'Store Order',
						isDisabled: true
					}
				]
			},
			// {
			// 	header: 'Discover',
			// 	i18n: 'Discover',
			// 	items: [
			// 		{
			// 			url: '/competer/discover',
			// 			name: 'Discover',
			// 			slug: 'competerDiscover',
			// 			icon: 'CodesandboxIcon',
			// 			i18n: 'Discover',
			// 		}
			// 	]
			// },

			{
				header: 'JK Paper',
				i18n: 'JK Paper',
				items: [
					{
						url: '/senser/dashboard',
						name: 'Dashboard',
						slug: 'dashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
						// isDisabled: true
					},
					{
						url: '/senser/demfor',
						name: 'DemFor',
						slug: 'demfor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					},
					{
						url: '/competer/dashboard',
						name: 'PriceEye',
						slug: 'competer',
						icon: 'EyeIcon',
						i18n: 'PriceEye',
						// isDisabled: true
					}
				]
			},

			{
				header: 'Onboard',
				i18n: 'Onboard',
				items: [
					{
						url: '/onboard/entities',
						name: 'Entities',
						slug: 'entities',
						icon: 'SlidersIcon',
						i18n: 'Entities',
						// isDisabled: true
					},
					{
						url: '/onboard/user-list',
						name: 'Users',
						slug: 'users',
						icon: 'SlidersIcon',
						i18n: 'Users',
						// isDisabled: true
					},
					{
						url: '/onboard/settings',
						name: 'Settings',
						slug: 'settings',
						icon: 'DollarSignIcon',
						i18n: 'Settings',
						// isDisabled: true
					}
				]
			},

			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						// isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						// isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/analyze/dashboard',                icon: 'HomeIcon',           is_bookmarked: false},
					{title: 'Alerts',                     url: '/analyze/alerts',                   icon: 'AlertOctagonIcon',   is_bookmarked: true},
					{title: 'Insights',                   url: '/analyze/explore',                  icon: 'EyeIcon',            is_bookmarked: true},
					{title: 'Sandbox',                    url: '/sandbox/explore',                  icon: 'CodesandboxIcon',    is_bookmarked: true},
					{title: 'Demand Forecast',            url: '/orbit/predictor',                  icon: 'SlidersIcon',        is_bookmarked: false},
					{title: 'Price Optimize',             url: '/orbit/optimizer',                  icon: 'DollarSignIcon',     is_bookmarked: false},
					{title: 'Price Eye',            	  url: '/competer/dashboard',               icon: 'EyeIcon',        	 is_bookmarked: false},
				]
			}
		},
		chart: {
			colors: ["#254689", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00"]
		}
	},
	xyz: {
		colors: {
			primary: '#6d1cbc',//'#5ec7ff', //'#3472cd',//'#49e4f8',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			note: '#6d1cbc',
			navbarColor: '#12c6fe'
		},
		config: {
			locale: 'en_IN',
			logo: 'logo-xyz.png',
			hasLogoFull: false,
			logoFull: 'logo-full-nex.png',
			title: 'xYz',
			hasPartner: true,
			logoPartner: 'logo-nex.png',
			env: 'lite',
			landingUrl: '/senser/dashboard'
		},
		menu: [
			{
				header: 'Paper Demo',
				i18n: 'Paper Demo',
				items: [
					{
						url: '/senser/dashboard',
						name: 'Dashboard',
						slug: 'dashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
						// isDisabled: true
					},
					{
						url: '/senser/demfor',
						name: 'DemFor',
						slug: 'demfor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					},
					{
						url: '/competer/dashboard',
						name: 'PriceEye',
						slug: 'competer',
						icon: 'EyeIcon',
						i18n: 'PriceEye',
						// isDisabled: true
					}
				]
			},
			{
				header: 'Grocer Demo',
				i18n: 'Grocer Demo',
				items: [
					{				
						url: null,
						name: 'Analyze',
						slug: 'analyze',
						icon: 'HomeIcon',
						i18n: 'analyze',
						// isDisabled: true,
						submenu: [
							{
								url: '/analyze/dashboard',
								name: 'Dashboard',
								slug: 'analyzeDashboard',
								i18n: 'Dashboard',
							},
							{
								url: '/analyze/alerts',
								name: 'Alerts',
								slug: 'analyzeAlerts',
								i18n: 'Alerts',
							},
							{
								url: '/analyze/explore',
								name: 'Insights',
								slug: 'analyzeExplore',
								icon: 'CodesandboxIcon',
								i18n: 'Insights',
							}
						]
					},
					{
						url: '/sandbox/explore',
						name: 'Explore',
						slug: 'sandboxExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Explore',
					},
					{
						url: '/orbit/predictor',
						name: 'DemFor',
						slug: 'predictor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					},
					{
						url: '/orbit/optimizer',
						name: 'PriceMind',
						slug: 'optimizer',
						icon: 'DollarSignIcon',
						i18n: 'PriceMind',
						// isDisabled: true
					},
				]
			},			

			{
				header: 'Onboard',
				i18n: 'Onboard',
				items: [
					{
						url: '/onboard/entities',
						name: 'Entities',
						slug: 'entities',
						icon: 'SlidersIcon',
						i18n: 'Entities',
						// isDisabled: true
					},
					{
						url: '/onboard/user-list',
						name: 'Users',
						slug: 'users',
						icon: 'SlidersIcon',
						i18n: 'Users',
						// isDisabled: true
					},
					{
						url: '/onboard/settings',
						name: 'Settings',
						slug: 'settings',
						icon: 'DollarSignIcon',
						i18n: 'Settings',
						// isDisabled: true
					}
				]
			},

			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						// isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						// isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/analyze/dashboard',                icon: 'HomeIcon',           is_bookmarked: false},
					{title: 'Alerts',                     url: '/analyze/alerts',                   icon: 'AlertOctagonIcon',   is_bookmarked: true},
					{title: 'Insights',                   url: '/analyze/explore',                  icon: 'EyeIcon',            is_bookmarked: true},
					{title: 'Sandbox',                    url: '/sandbox/explore',                  icon: 'CodesandboxIcon',    is_bookmarked: true},
					{title: 'Demand Forecast',            url: '/orbit/predictor',                  icon: 'SlidersIcon',        is_bookmarked: false},
					{title: 'Price Optimize',             url: '/orbit/optimizer',                  icon: 'DollarSignIcon',     is_bookmarked: false},
					{title: 'Price Eye',            	  url: '/competer/dashboard',               icon: 'EyeIcon',        	 is_bookmarked: false},
				]
			}
		},
		chart: {
			colors: ["#6d1cbc", "#12c6fe", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00"]
		}
	},
	gex: {
		colors: {
			primary: '#28c76f',//'#00d1c1', //'#5a5883', //'#71b64a', //'#7367F0',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			navbarColor: '#28c76f'
		},
		config: {
			locale: 'en_US',
			logo: 'logo-nex.png',
			hasLogoFull: true,
			logoFull: 'logo-full-gex.png',
			title: '',
			hasPartner: true,
			logoPartner: 'logo-gex.png'
		},
		menu: [
			{
				url: null,
				name: 'Analyze',
				slug: 'analyze',
				icon: 'HomeIcon',
				i18n: 'Analyze',
				// isDisabled: true,
				submenu: [
					{
						url: '/analyze/dashboard',
						name: 'Dashboard',
						slug: 'analyzeDashboard',
						i18n: 'Dashboard',
					},
					{
						url: '/analyze/alerts',
						name: 'Alerts',
						slug: 'analyzeAlerts',
						i18n: 'Alerts',
					},
					{
						url: '/analyze/explore',
						name: 'Insights',
						slug: 'analyzeExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Insights',
					}
				]
			},
			{
				header: 'Sandbox',
				i18n: 'Sandbox',
				items: [
					{
						url: '/sandbox/explore',
						name: 'Explore',
						slug: 'sandboxExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Explore',
					}
				]
			},

			{
				header: 'Orbits',
				i18n: 'Orbits',
				items: [
					{
						url: '/orbit/predictor',
						name: 'Demand Forecast',
						slug: 'predictor',
						icon: 'SlidersIcon',
						i18n: 'Demand Forecast',
						// isDisabled: true
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/analyze/dashboard',                icon: 'HomeIcon',           is_bookmarked: false},
					{title: 'Alerts',                     url: '/analyze/alerts',                   icon: 'AlertOctagonIcon',   is_bookmarked: true},
					{title: 'Insights',                   url: '/analyze/explore',                  icon: 'EyeIcon',            is_bookmarked: true},
					{title: 'Sandbox',                    url: '/sandbox/explore',                  icon: 'CodesandboxIcon',    is_bookmarked: true},
					{title: 'Demand Forecast',            url: '/orbit/predictor',                  icon: 'SlidersIcon',        is_bookmarked: false},
				]
			}
		},
		chart: {
			colors: ["#28c76f", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00"]
		}
	},
	sdg: {
		colors: {
			primary: '#0171b6',//'#7367F0',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			navbarColor: '#fcaf17'
		},
		config: {
			locale: 'en_AE',
			logo: 'logo-nex.png',
			hasLogoFull: true,
			logoFull: 'logo-full-nex.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-sdg.png',
			landingUrl: '/competer/dashboard'
		},
		menu: [
			{
				url: null,
				name: 'PriceEye',
				slug: 'competer',
				icon: 'HomeIcon',
				i18n: 'PriceEye',
				// isDisabled: true,
				submenu: [
					{
						url: '/competer/dashboard',
						name: 'Dashboard',
						slug: 'competerDashboard',
						i18n: 'Dashboard',
					},
					{
						url: '/competer/stock',
						name: 'Stock',
						slug: 'competerStock',
						icon: 'GridIcon',
						i18n: 'Stock',
					},
					{
						url: '/competer/explore',
						name: 'Insights',
						slug: 'competerExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Insights',
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/competer/dashboard',                icon: 'EyeIcon',           is_bookmarked: true},
					{title: 'Stock',                      url: '/competer/stock',                    icon: 'GridIcon',   is_bookmarked: true},
					{title: 'Insight',                      url: '/competer/explore',                    icon: 'CodesandboxIcon',   is_bookmarked: true}
				]
			}
		},
		chart: {
			colors: ["#0171b6", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00"]
		}
	},
	osdg: {
		colors: {
			primary: '#0171b6',//'#7367F0',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			navbarColor: '#fcaf17'
		},
		config: {
			locale: 'en_AE',
			logo: 'logo-nex.png',
			hasLogoFull: true,
			logoFull: 'logo-full-nex.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-sdg.png',
			landingUrl: '/competer/dashboard'
		},
		menu: [
			{
				url: null,
				name: 'Analyze',
				slug: 'analyze',
				icon: 'HomeIcon',
				i18n: 'analyze',
				isDisabled: true,
				submenu: [
					{
						url: '/analyze/dashboard',
						name: 'Dashboard',
						slug: 'analyzeDashboard',
						i18n: 'Dashboard',
					},
					{
						url: '/analyze/alerts',
						name: 'Alerts',
						slug: 'analyzeAlerts',
						i18n: 'Alerts',
					},
					{
						url: '/analyze/explore',
						name: 'Insights',
						slug: 'analyzeExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Insights',
					}
				]
			},
			{
				header: 'Sandbox',
				i18n: 'Sandbox',
				items: [
					{
						url: '/sandbox/explore',
						name: 'Explore',
						slug: 'sandboxExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Explore',
						isDisabled: true,
					}
				]
			},
			{
				header: 'Orbits',
				i18n: 'Orbits',
				items: [
					{
						url: '/orbit/predictor',
						name: 'DemFor',
						slug: 'predictor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						isDisabled: true
					},
					{
						url: '/orbit/optimizer',
						name: 'PriceMind',
						slug: 'optimizer',
						icon: 'DollarSignIcon',
						i18n: 'PriceMind',
						isDisabled: true
					},
					{
						url: '/competer/dashboard',
						name: 'PriceEye',
						slug: 'competer',
						icon: 'EyeIcon',
						i18n: 'PriceEye',
						// isDisabled: true
					},
					// {
					// 	url: '',
					// 	name: 'PriceEye',
					// 	slug: 'competer',
					// 	icon: 'EyeIcon',
					// 	i18n: 'PriceEye',
					// 	// isDisabled: true,
					// 	submenu: [
					// 		{
					// 			url: '/competer/dashboard',
					// 			name: 'Dashboard',
					// 			slug: 'competerDashboard',
					// 			i18n: 'Dashboard',
					// 		},
					// 		{
					// 			url: '/competer/alerts',
					// 			name: 'Alerts',
					// 			slug: 'competerAlerts',
					// 			i18n: 'Alerts',
					// 		},
					// 		{
					// 			url: '/competer/explore',
					// 			name: 'Insights',
					// 			slug: 'competerExplore',
					// 			icon: 'CodesandboxIcon',
					// 			i18n: 'Insights',
					// 		}
					// 	]
					// },
					{
						url: '/orbits/order',
						name: 'Store Order',
						slug: 'order',
						icon: 'TruckIcon',
						i18n: 'Store Order',
						isDisabled: true
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/competer/dashboard',                icon: 'EyeIcon',           is_bookmarked: true},
					{title: 'Stock',                      url: '/competer/stock',                    icon: 'CodesandboxIcon',   is_bookmarked: true}
				]
			}
		},
		chart: {
			colors: ["#0171b6", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"]
		}
	},
	levis: {
		colors: {
			primary: '#c51130',//'#7367F0',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			navbarColor: '#294773'
		},
		config: {
			locale: 'en_EU',
			logo: 'logo-nex.png',
			hasLogoFull: true,
			logoFull: 'logo-full-nex.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-levis.png',
			landingUrl: '/competer/dashboard'
		},
		menu: [
			{
				url: null,
				name: 'PriceEye',
				slug: 'competer',
				icon: 'HomeIcon',
				i18n: 'PriceEye',
				// isDisabled: true,
				submenu: [
					{
						url: '/competer/dashboard',
						name: 'Dashboard',
						slug: 'competerDashboard',
						i18n: 'Dashboard',
					},
					{
						url: '/competer/stock',
						name: 'Stock',
						slug: 'competerStock',
						icon: 'GridIcon',
						i18n: 'Stock',
					},
					{
						url: '/competer/explore',
						name: 'Insights',
						slug: 'competerExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Insights',
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/competer/dashboard',                icon: 'EyeIcon',           is_bookmarked: true},
					{title: 'Stock',                      url: '/competer/stock',                    icon: 'GridIcon',   is_bookmarked: true},
					{title: 'Insight',                      url: '/competer/explore',                    icon: 'CodesandboxIcon',   is_bookmarked: true}
				]
			}
		},
		chart: {
			colors: ["#c51130", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"]
		}
	},
	kks: {
		colors: {
			primary: '#7C3',//'#7367F0',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			navbarColor: '#07B'
		},
		config: {
			locale: 'en_EU',
			logo: 'logo-nex.png',
			hasLogoFull: true,
			logoFull: 'logo-full-nex.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-kks.png',
			landingUrl: '/competer/dashboard'
		},
		menu: [
			{
				url: null,
				name: 'PriceEye',
				slug: 'competer',
				icon: 'HomeIcon',
				i18n: 'PriceEye',
				// isDisabled: true,
				submenu: [
					{
						url: '/competer/dashboard',
						name: 'Dashboard',
						slug: 'competerDashboard',
						i18n: 'Dashboard',
					},
					{
						url: '/competer/stock',
						name: 'Stock',
						slug: 'competerStock',
						icon: 'GridIcon',
						i18n: 'Stock',
					},
					{
						url: '/competer/explore',
						name: 'Insights',
						slug: 'competerExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Insights',
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/competer/dashboard',                icon: 'EyeIcon',           is_bookmarked: true},
					{title: 'Stock',                      url: '/competer/stock',                    icon: 'GridIcon',   is_bookmarked: true},
					{title: 'Insight',                      url: '/competer/explore',                    icon: 'CodesandboxIcon',   is_bookmarked: true}
				]
			}
		},
		chart: {
			colors: ["#c51130", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"]
		}
	},
	djonesold: {
		colors: {
			primary: '#101116',//'#7367F0',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			navbarColor: '#101116'
		},
		config: {
			locale: 'en_AU',
			logo: 'logo-nex.png',
			hasLogoFull: true,
			logoFull: 'logo-full-nex.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-dj.svg',
			landingUrl: '/competer/dashboard'
		},
		menu: [
			{
				url: null,
				name: 'PriceEye',
				slug: 'competer',
				icon: 'HomeIcon',
				i18n: 'PriceEye',
				// isDisabled: true,
				submenu: [
					{
						url: '/competer/dashboard',
						name: 'Dashboard',
						slug: 'competerDashboard',
						i18n: 'Dashboard',
					},
					{
						url: '/competer/stock',
						name: 'Stock',
						slug: 'competerStock',
						icon: 'GridIcon',
						i18n: 'Stock',
					},
					{
						url: '/competer/explore',
						name: 'Insights',
						slug: 'competerExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Insights',
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/competer/dashboard',                icon: 'EyeIcon',           is_bookmarked: true},
					{title: 'Stock',                      url: '/competer/stock',                    icon: 'GridIcon',   is_bookmarked: true},
					{title: 'Insight',                      url: '/competer/explore',                    icon: 'CodesandboxIcon',   is_bookmarked: true}
				]
			}
		},
		chart: {
			colors: ["#101116", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"]
		}
	},
	kelloggs: {
		colors: {
			primary: '#1877f2',//'#5ec7ff', //'#d41545',//'#3472cd',//'#49e4f8',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			note: '#5ec7ff',
			// navbarColor: commonConfig.color.white
		},
		config: {
			locale: 'en_US',
			logo: 'logo-kelloggs.png',
			hasLogoFull: true,
			logoFull: 'logo-full-kelloggs.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-nex.png',
			env: 'lite',
			landingUrl: '/competer/dashboard'
		},
		menu: [
			{
				header: 'Orbits',
				i18n: 'Orbits',
				items: [
					{
						url: '/competer/dashboard',
						name: 'PriceEye',
						slug: 'competer',
						icon: 'EyeIcon',
						i18n: 'PriceEye',
						// isDisabled: true
					},
					{
						url: '/orbit/predictor',
						name: 'DemFor',
						slug: 'predictor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					},
					{
						url: '/orbit/optimizer',
						name: 'PriceMind',
						slug: 'optimizer',
						icon: 'DollarSignIcon',
						i18n: 'PriceMind',
						// isDisabled: true
					},
					{
						url: '/orbits/order',
						name: 'Store Order',
						slug: 'order',
						icon: 'TruckIcon',
						i18n: 'Store Order',
						isDisabled: true
					}
				]
			},
			{
				header: 'Intelligence',
				i18n: 'Intelligence',
				items: [
					{
						url: '/analyze/dashboard',
						name: 'Dashboard',
						slug: 'analyzeDashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
					},
					{
						url: '/analyze/alerts',
						name: 'Alerts',
						slug: 'analyzeAlerts',
						icon: 'BellIcon',
						i18n: 'Alerts',
					},
					{
						url: '/analyze/explore',
						name: 'Insights',
						slug: 'analyzeExplore',
						icon: 'ActivityIcon',
						i18n: 'Insights',
					},
					{
						url: '/sandbox/explore',
						name: 'Explore',
						slug: 'sandboxExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Explore',
					}
				]
			},
			{
				header: 'Market Focus',
				i18n: 'Market Focus',
				items: [
					{
						url: '/senser/dashboard',
						name: 'Dashboard',
						slug: 'dashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
						// isDisabled: true
					},
					{
						url: '/senser/demfor',
						name: 'DemFor',
						slug: 'demfor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/analyze/dashboard',                icon: 'HomeIcon',           is_bookmarked: false},
					{title: 'Alerts',                     url: '/analyze/alerts',                   icon: 'AlertOctagonIcon',   is_bookmarked: true},
					{title: 'Insights',                   url: '/analyze/explore',                  icon: 'EyeIcon',            is_bookmarked: true},
					{title: 'Sandbox',                    url: '/sandbox/explore',                  icon: 'CodesandboxIcon',    is_bookmarked: true},
					{title: 'Demand Forecast',            url: '/orbit/predictor',                  icon: 'SlidersIcon',        is_bookmarked: false},
					{title: 'Price Optimize',             url: '/orbit/optimizer',                  icon: 'DollarSignIcon',     is_bookmarked: false},
					{title: 'Price Eye',            	  url: '/competer/dashboard',               icon: 'EyeIcon',        	 is_bookmarked: false},
				]
			}
		},
		chart: {
			colors: [commonConfig.color.blue, commonConfig.color.navy, commonConfig.color.water, commonConfig.color.cupcake, commonConfig.color.cyan, commonConfig.color.darkness, commonConfig.color.egg, commonConfig.color.gray]
			// colors: ["#5ec7ff", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00"]
			// colors: ["#aa2a3d", "#c42f58", "#d41545", "#e92343", "#f54b2d", "#FF9F43", "#f2bb3c", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00", "#f54b2f"]
		}
	},
	heb: {
		colors: {
			primary: '#1877f2',//'#5ec7ff', //'#d41545',//'#3472cd',//'#49e4f8',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			note: '#5ec7ff',
			// navbarColor: commonConfig.color.white
		},
		config: {
			locale: 'en_US',
			logo: 'logo-heb.png',
			hasLogoFull: true,
			logoFull: 'logo-full-heb.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-nex.png',
			env: 'lite',
			landingUrl: '/competer/dashboard'
		},
		menu: [
			{
				header: 'Orbits',
				i18n: 'Orbits',
				items: [
					{
						url: '/competer/dashboard',
						name: 'PriceEye',
						slug: 'competer',
						icon: 'EyeIcon',
						i18n: 'PriceEye',
						// isDisabled: true
					},
					{
						url: '/orbit/predictor',
						name: 'DemFor',
						slug: 'predictor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					},
					{
						url: '/orbit/optimizer',
						name: 'PriceMind',
						slug: 'optimizer',
						icon: 'DollarSignIcon',
						i18n: 'PriceMind',
						// isDisabled: true
					},
					{
						url: '/orbits/order',
						name: 'Store Order',
						slug: 'order',
						icon: 'TruckIcon',
						i18n: 'Store Order',
						isDisabled: true
					}
				]
			},
			{
				header: 'Intelligence',
				i18n: 'Intelligence',
				items: [
					{
						url: '/analyze/dashboard',
						name: 'Dashboard',
						slug: 'analyzeDashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
					},
					{
						url: '/analyze/alerts',
						name: 'Alerts',
						slug: 'analyzeAlerts',
						icon: 'BellIcon',
						i18n: 'Alerts',
					},
					{
						url: '/analyze/explore',
						name: 'Insights',
						slug: 'analyzeExplore',
						icon: 'ActivityIcon',
						i18n: 'Insights',
					},
					{
						url: '/sandbox/explore',
						name: 'Explore',
						slug: 'sandboxExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Explore',
					}
				]
			},
			{
				header: 'Market Focus',
				i18n: 'Market Focus',
				items: [
					{
						url: '/senser/dashboard',
						name: 'Dashboard',
						slug: 'dashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
						// isDisabled: true
					},
					{
						url: '/senser/demfor',
						name: 'DemFor',
						slug: 'demfor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/analyze/dashboard',                icon: 'HomeIcon',           is_bookmarked: false},
					{title: 'Alerts',                     url: '/analyze/alerts',                   icon: 'AlertOctagonIcon',   is_bookmarked: true},
					{title: 'Insights',                   url: '/analyze/explore',                  icon: 'EyeIcon',            is_bookmarked: true},
					{title: 'Sandbox',                    url: '/sandbox/explore',                  icon: 'CodesandboxIcon',    is_bookmarked: true},
					{title: 'Demand Forecast',            url: '/orbit/predictor',                  icon: 'SlidersIcon',        is_bookmarked: false},
					{title: 'Price Optimize',             url: '/orbit/optimizer',                  icon: 'DollarSignIcon',     is_bookmarked: false},
					{title: 'Price Eye',            	  url: '/competer/dashboard',               icon: 'EyeIcon',        	 is_bookmarked: false},
				]
			}
		},
		chart: {
			colors: [commonConfig.color.blue, commonConfig.color.navy, commonConfig.color.water, commonConfig.color.cupcake, commonConfig.color.cyan, commonConfig.color.darkness, commonConfig.color.lime, commonConfig.color.egg, commonConfig.color.gray]
			// colors: ["#5ec7ff", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00"]
			// colors: ["#aa2a3d", "#c42f58", "#d41545", "#e92343", "#f54b2d", "#FF9F43", "#f2bb3c", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00", "#f54b2f"]
		}
	},
	limeroad: {
		colors: {
			primary: '#1877f2',//'#5ec7ff', //'#d41545',//'#3472cd',//'#49e4f8',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			note: '#5ec7ff',
			// navbarColor: commonConfig.color.white
		},
		config: {
			locale: 'en_US',
			logo: 'logo-limeroad.png',
			hasLogoFull: false,
			logoFull: 'logo-full-heb.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-nex.png',
			env: 'lite',
			landingUrl: '/competer/dashboard'
		},
		menu: [
			{
				header: 'Orbits',
				i18n: 'Orbits',
				items: [
					{
						url: '/competer/dashboard',
						name: 'PriceEye',
						slug: 'competer',
						icon: 'EyeIcon',
						i18n: 'PriceEye',
						// isDisabled: true
					},
					{
						url: '/orbit/predictor',
						name: 'DemFor',
						slug: 'predictor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					},
					{
						url: '/orbit/optimizer',
						name: 'PriceMind',
						slug: 'optimizer',
						icon: 'DollarSignIcon',
						i18n: 'PriceMind',
						// isDisabled: true
					},
					{
						url: '/orbits/order',
						name: 'Store Order',
						slug: 'order',
						icon: 'TruckIcon',
						i18n: 'Store Order',
						isDisabled: true
					}
				]
			},
			{
				header: 'Intelligence',
				i18n: 'Intelligence',
				items: [
					{
						url: '/analyze/dashboard',
						name: 'Dashboard',
						slug: 'analyzeDashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
					},
					{
						url: '/analyze/alerts',
						name: 'Alerts',
						slug: 'analyzeAlerts',
						icon: 'BellIcon',
						i18n: 'Alerts',
					},
					{
						url: '/analyze/explore',
						name: 'Insights',
						slug: 'analyzeExplore',
						icon: 'ActivityIcon',
						i18n: 'Insights',
					},
					{
						url: '/sandbox/explore',
						name: 'Explore',
						slug: 'sandboxExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Explore',
					}
				]
			},
			{
				header: 'Market Focus',
				i18n: 'Market Focus',
				items: [
					{
						url: '/senser/dashboard',
						name: 'Dashboard',
						slug: 'dashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
						// isDisabled: true
					},
					{
						url: '/senser/demfor',
						name: 'DemFor',
						slug: 'demfor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/analyze/dashboard',                icon: 'HomeIcon',           is_bookmarked: false},
					{title: 'Alerts',                     url: '/analyze/alerts',                   icon: 'AlertOctagonIcon',   is_bookmarked: true},
					{title: 'Insights',                   url: '/analyze/explore',                  icon: 'EyeIcon',            is_bookmarked: true},
					{title: 'Sandbox',                    url: '/sandbox/explore',                  icon: 'CodesandboxIcon',    is_bookmarked: true},
					{title: 'Demand Forecast',            url: '/orbit/predictor',                  icon: 'SlidersIcon',        is_bookmarked: false},
					{title: 'Price Optimize',             url: '/orbit/optimizer',                  icon: 'DollarSignIcon',     is_bookmarked: false},
					{title: 'Price Eye',            	  url: '/competer/dashboard',               icon: 'EyeIcon',        	 is_bookmarked: false},
				]
			}
		},
		chart: {
			colors: [commonConfig.color.blue, commonConfig.color.navy, commonConfig.color.water, commonConfig.color.cupcake, commonConfig.color.cyan, commonConfig.color.darkness, commonConfig.color.lime, commonConfig.color.egg, commonConfig.color.gray]
			// colors: ["#5ec7ff", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00"]
			// colors: ["#aa2a3d", "#c42f58", "#d41545", "#e92343", "#f54b2d", "#FF9F43", "#f2bb3c", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00", "#f54b2f"]
		}
	},
	djones: {
		colors: {
			primary: '#1877f2',//'#5ec7ff', //'#d41545',//'#3472cd',//'#49e4f8',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			note: '#5ec7ff',
			// navbarColor: commonConfig.color.white
		},
		config: {
			locale: 'en_AU',
			logo: 'logo-dj.svg',
			hasLogoFull: false,
			logoFull: 'logo-full-heb.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-nex.png',
			env: 'lite',
			landingUrl: '/competer/dashboard'
		},
		menu: [
			{
				header: 'Orbits',
				i18n: 'Orbits',
				items: [
					{
						url: '/competer/dashboard',
						name: 'PriceEye',
						slug: 'competer',
						icon: 'EyeIcon',
						i18n: 'PriceEye',
						// isDisabled: true
					},
					{
						url: '/orbit/predictor',
						name: 'DemFor',
						slug: 'predictor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					},
					{
						url: '/orbit/optimizer',
						name: 'PriceMind',
						slug: 'optimizer',
						icon: 'DollarSignIcon',
						i18n: 'PriceMind',
						// isDisabled: true
					},
					{
						url: '/orbits/order',
						name: 'Store Order',
						slug: 'order',
						icon: 'TruckIcon',
						i18n: 'Store Order',
						isDisabled: true
					}
				]
			},
			{
				header: 'Intelligence',
				i18n: 'Intelligence',
				items: [
					{
						url: '/analyze/dashboard',
						name: 'Dashboard',
						slug: 'analyzeDashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
					},
					{
						url: '/analyze/alerts',
						name: 'Alerts',
						slug: 'analyzeAlerts',
						icon: 'BellIcon',
						i18n: 'Alerts',
					},
					{
						url: '/analyze/explore',
						name: 'Insights',
						slug: 'analyzeExplore',
						icon: 'ActivityIcon',
						i18n: 'Insights',
					},
					{
						url: '/sandbox/explore',
						name: 'Explore',
						slug: 'sandboxExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Explore',
					}
				]
			},
			{
				header: 'Market Focus',
				i18n: 'Market Focus',
				items: [
					{
						url: '/senser/dashboard',
						name: 'Dashboard',
						slug: 'dashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
						// isDisabled: true
					},
					{
						url: '/senser/demfor',
						name: 'DemFor',
						slug: 'demfor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/analyze/dashboard',                icon: 'HomeIcon',           is_bookmarked: false},
					{title: 'Alerts',                     url: '/analyze/alerts',                   icon: 'AlertOctagonIcon',   is_bookmarked: true},
					{title: 'Insights',                   url: '/analyze/explore',                  icon: 'EyeIcon',            is_bookmarked: true},
					{title: 'Sandbox',                    url: '/sandbox/explore',                  icon: 'CodesandboxIcon',    is_bookmarked: true},
					{title: 'Demand Forecast',            url: '/orbit/predictor',                  icon: 'SlidersIcon',        is_bookmarked: false},
					{title: 'Price Optimize',             url: '/orbit/optimizer',                  icon: 'DollarSignIcon',     is_bookmarked: false},
					{title: 'Price Eye',            	  url: '/competer/dashboard',               icon: 'EyeIcon',        	 is_bookmarked: false},
				]
			}
		},
		chart: {
			colors: [commonConfig.color.blue, commonConfig.color.navy, commonConfig.color.water, commonConfig.color.cupcake, commonConfig.color.cyan, commonConfig.color.darkness, commonConfig.color.lime, commonConfig.color.egg, commonConfig.color.gray]
			// colors: ["#5ec7ff", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00"]
			// colors: ["#aa2a3d", "#c42f58", "#d41545", "#e92343", "#f54b2d", "#FF9F43", "#f2bb3c", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00", "#f54b2f"]
		}
	},
	myers: {
		colors: {
			primary: '#1877f2',//'#5ec7ff', //'#d41545',//'#3472cd',//'#49e4f8',
			success: '#28C76F',
			danger: '#EA5455',
			warning: '#FF9F43',
			dark: '#1E1E1E',
			note: '#5ec7ff',
			// navbarColor: commonConfig.color.white
		},
		config: {
			locale: 'en_AU',
			logo: 'logo-myers.svg',
			hasLogoFull: false,
			logoFull: 'logo-full-heb.png',
			title: 'NextOrbit',
			hasPartner: true,
			logoPartner: 'logo-nex.png',
			env: 'lite',
			landingUrl: '/competer/dashboard'
		},
		menu: [
			{
				header: 'Orbits',
				i18n: 'Orbits',
				items: [
					{
						url: '/competer/dashboard',
						name: 'PriceEye',
						slug: 'competer',
						icon: 'EyeIcon',
						i18n: 'PriceEye',
						// isDisabled: true
					},
					{
						url: '/orbit/predictor',
						name: 'DemFor',
						slug: 'predictor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						isDisabled: true
					},
					{
						url: '/orbit/optimizer',
						name: 'PriceMind',
						slug: 'optimizer',
						icon: 'DollarSignIcon',
						i18n: 'PriceMind',
						isDisabled: true
					},
					{
						url: '/orbits/order',
						name: 'Store Order',
						slug: 'order',
						icon: 'TruckIcon',
						i18n: 'Store Order',
						isDisabled: true
					}
				]
			},
			{
				header: 'Intelligence',
				i18n: 'Intelligence',
				items: [
					{
						url: '/analyze/dashboard',
						name: 'Dashboard',
						slug: 'analyzeDashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
						isDisabled: true
					},
					{
						url: '/analyze/alerts',
						name: 'Alerts',
						slug: 'analyzeAlerts',
						icon: 'BellIcon',
						i18n: 'Alerts',
						isDisabled: true
					},
					{
						url: '/analyze/explore',
						name: 'Insights',
						slug: 'analyzeExplore',
						icon: 'ActivityIcon',
						i18n: 'Insights',
						isDisabled: true
					},
					{
						url: '/sandbox/explore',
						name: 'Explore',
						slug: 'sandboxExplore',
						icon: 'CodesandboxIcon',
						i18n: 'Explore',
						isDisabled: true
					}
				]
			},
			{
				header: 'Market Focus',
				i18n: 'Market Focus',
				items: [
					{
						url: '/senser/dashboard',
						name: 'Dashboard',
						slug: 'dashboard',
						icon: 'PieChartIcon',
						i18n: 'Dashboard',
						// isDisabled: true
					},
					{
						url: '/senser/demfor',
						name: 'DemFor',
						slug: 'demfor',
						icon: 'SlidersIcon',
						i18n: 'DemFor',
						// isDisabled: true
					}
				]
			},
			{
				header: 'Support',
				i18n: 'Support',
				items: [
					{
						url: '/pages/faq',
						name: 'FAQ',
						slug: 'faq',
						icon: 'HelpCircleIcon',
						i18n: 'FAQ',
						isDisabled: true

					},
					{
						url: '/pages/knowledge-base',
						name: 'Knowledge Base',
						slug: 'kbase',
						icon: 'InfoIcon',
						i18n: 'KnowledgeBase',
						isDisabled: true

					}
				]
			}
		],
		navbarSearchAndPinList: {
			pages: {
				key: "title",
				data: [
					// DASHBOARDS
					{title: 'Dashboard',                  url: '/analyze/dashboard',                icon: 'HomeIcon',           is_bookmarked: false},
					{title: 'Alerts',                     url: '/analyze/alerts',                   icon: 'AlertOctagonIcon',   is_bookmarked: true},
					{title: 'Insights',                   url: '/analyze/explore',                  icon: 'EyeIcon',            is_bookmarked: true},
					{title: 'Sandbox',                    url: '/sandbox/explore',                  icon: 'CodesandboxIcon',    is_bookmarked: true},
					{title: 'Demand Forecast',            url: '/orbit/predictor',                  icon: 'SlidersIcon',        is_bookmarked: false},
					{title: 'Price Optimize',             url: '/orbit/optimizer',                  icon: 'DollarSignIcon',     is_bookmarked: false},
					{title: 'Price Eye',            	  url: '/competer/dashboard',               icon: 'EyeIcon',        	 is_bookmarked: false},
				]
			}
		},
		chart: {
			colors: [commonConfig.color.blue, commonConfig.color.navy, commonConfig.color.water, commonConfig.color.cupcake, commonConfig.color.cyan, commonConfig.color.darkness, commonConfig.color.lime, commonConfig.color.egg, commonConfig.color.gray]
			// colors: ["#5ec7ff", "#DCE6EC", "#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00"]
			// colors: ["#aa2a3d", "#c42f58", "#d41545", "#e92343", "#f54b2d", "#FF9F43", "#f2bb3c", "#1E1E1E", "#DCE6EC", "#fcaf17", "#0171b6", "#4278f5", "#fcba03","#ffef00", "#f54b2f"]
		}
	}
};

let appConfig = platformConfig[appCode];
appConfig.common = commonConfig;

export default appConfig
